import { TableComment } from "../../../../general/src/TableComment";
import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOriginDestinationRate extends Layout {
    buttonDistanceLookup: Button;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    labelDistanceLookup: Label;
    layoutComments: TableComment;
    panelIntermediate: Panel;
    panelIntermediateValue: Panel;
    panelRate: Panel;
    sourceComments: DataSource;
    sourceMultistopDummy: DataSource;
    sourceOriginDestinationRate: DataSource;
    switchMultistop: Switch;
    switchPtToPt: Switch;
    tabComments: Tab;
    tabRate: Tab;
    tableMultistop: Table;
    tabsetComments: Tabset;
    tabsetCommitments: Tabset;
    textboxBillDistance: Textbox;
    textboxDescr: Textbox;
    textboxDestCityName: Textbox;
    textboxDestState: Textbox;
    textboxDestination: Textbox;
    textboxDestinationCode: Textbox;
    textboxEffectiveDate: Textbox;
    textboxExpirationDate: Textbox;
    textboxIntermediate: Textbox;
    textboxIntermediateCityName: Textbox;
    textboxIntermediateCode: Textbox;
    textboxIntermediateState: Textbox;
    textboxLastUsedDate: Textbox;
    textboxMinimumCharge: Textbox;
    textboxOrigCityName: Textbox;
    textboxOrigState: Textbox;
    textboxOrigin: Textbox;
    textboxOriginCode: Textbox;
    textboxRateFreeform: Textbox;
    textboxRateLookup: Textbox;
    textboxRateMethod: Textbox;
    textboxTimesUsed: Textbox;
}
